/**
 這支檔案沒有包含所有的 shoplytics tracker，
 舊有的 shoplytics tracker 還是在 service.trackers.js 中

 This file does not include all of the shoplytics trackers;
 the existing shoplytics trackers are still in the service.trackers.js file.
 */
import { isString, isFunction, isNil, curryRight, pick } from 'lodash-es';
import {
  EVENT_NAME_FOR_PRODUCT_LIST,
  ONE_PAGE_STORE_TRACKER_TYPE,
  MENU_TRACKER_TYPE,
  CART_REVAMP_TRACKER_TYPE,
  CART_TRACKER_TYPE_FOR_V1_AND_V2,
  CART_TRACKER_TYPE,
  CHECKOUT_TRACKER_TYPE,
  EVENT_FOR_MEMBER_CENTER,
  EVENT_NAME_FOR_CHECKOUT,
  EVENT_NAME_FOR_USER_FLOW,
  EVENT_NAME_FOR_COUPON_CENTER,
} from '../constants/tracker';

/**
 * Send event data to Shoplytics Event Tracker
 *
 * @typedef EventPayload
 * @prop {string=} event_name
 * @prop {string=} event_category
 * @prop {string=} user_id
 * @prop {string=} channel_id - store id in Shoplytics
 * @prop {string=} data - stringified JSON - TODO: replace with v2 `event_data`
 *
 * @param {string} eventName
 * @param {EventPayload} data
 */
export function track(eventName, data = {}) {
  // Shoplytics tracker will only be loaded after obtaining user consent
  if (isString(eventName) && isFunction(shoplytics)) {
    shoplytics('track', eventName, data);
  }
}

export const buildEventPayloadByProps = curryRight(
  (data, props, userId) => ({
    user_id: userId,
    data: JSON.stringify(pick(data, props)),
  }),
  3,
);

export function buildTrackDataForEventsUserFlow(event, data, userId) {
  const { event_category, property } = data;
  // value could be false, so we need to check if it's undefined or null
  const value = isNil(data.value) ? null : data.value;

  return {
    event_category,
    user_id: userId,
    data: JSON.stringify({ property, value }),
  };
}

export function trackerShoplytics($rootScope, mainConfig, trackerService) {
  const { generalEventType } = trackerService;
  const userId = mainConfig.currentUser?._id ?? null;

  const buildEventPayloadByPropsWithUserId = buildEventPayloadByProps(userId);

  function buildTrackDataWithScope(data) {
    const { scope = 'shop', ...restData } = data;

    return {
      data: JSON.stringify(restData),
      scope,
    };
  }

  function getTrackData({
    event_category,
    user_id = userId,
    scope = 'shop',
    ...rest
  }) {
    return {
      event_category,
      user_id,
      data: JSON.stringify(rest),
      scope,
    };
  }

  /**
   * Page View
   */

  // PageView - Since app.js precedes tracker.shoplytics.js execution, it should remain in services.tracker.js.

  /**
   * Signup Flow
   */
  $rootScope.$on(generalEventType.MemberSignUpFormShow, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.MemberSignUpFormSubmit, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.ThirdPartySignUpClick, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.ThirdPartyLoginClick, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    if (typeof shoplytics === 'function') {
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(generalEventType.MemberLoginClick, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.SMSVerificationCodeSend, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.SMSVerificationFormShow, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(
    generalEventType.SMSVerificationSendButtonClick,
    (event, data) => {
      const eventName = event.name;
      const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

      track(eventName, trackData);
    },
  );

  $rootScope.$on(generalEventType.SMSVerificationSubmit, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.RecaptchaVerificationStart, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(
    generalEventType.RecaptchaVerificationComplete,
    (event, data) => {
      const eventName = event.name;
      const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

      track(eventName, trackData);
    },
  );

  $rootScope.$on(generalEventType.MemberSignUpInfoFormShow, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.MemberSignUpInfoSubmit, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.MemberSignUpSucceed, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.MemberLoginFormShow, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.MemberLoginFormSubmit, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.MemberLoginSucceed, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.UpdateMemberInfoFormShow, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  $rootScope.$on(generalEventType.UpdateMemberInfoSucceed, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataForEventsUserFlow(event, data, userId);

    track(eventName, trackData);
  });

  /**
   * Product Detail Page Tab Click
   */
  $rootScope.$on(generalEventType.PDPTabClick, (event, data) => {
    const eventName = event.name;
    const trackData = buildEventPayloadByPropsWithUserId(data, ['tab_name']);

    track(eventName, trackData);
  });

  /**
   * Product List
   */
  $rootScope.$on(
    EVENT_NAME_FOR_PRODUCT_LIST.RecommendItem,
    (event, data = {}) => {
      const eventName = event.name;
      const trackData = buildEventPayloadByPropsWithUserId(data, [
        'product_id',
        'based_product_id',
        'rank',
        'rec_strategy',
        'layout_setting',
        'page_type',
      ]);

      track(eventName, trackData);
    },
  );

  $rootScope.$on(
    EVENT_NAME_FOR_PRODUCT_LIST.ProductClick,
    (event, data = {}) => {
      const eventName = event.name;
      const trackData = buildEventPayloadByPropsWithUserId(data, [
        'page_type',
        'product_id',
      ]);

      track(eventName, trackData);
    },
  );

  $rootScope.$on(
    EVENT_NAME_FOR_PRODUCT_LIST.ViewRelatedProducts,
    (event, data = {}) => {
      const eventName = event.name;
      const trackData = buildEventPayloadByPropsWithUserId(data, [
        'product_infos',
      ]);

      track(eventName, trackData);
    },
  );

  $rootScope.$on(
    EVENT_NAME_FOR_PRODUCT_LIST.WishlistAdd,
    (event, data = {}) => {
      const eventName = event.name;
      const trackData = buildEventPayloadByPropsWithUserId(data, [
        'product_id',
      ]);

      track(eventName, trackData);
    },
  );

  $rootScope.$on(
    EVENT_NAME_FOR_PRODUCT_LIST.WishlistRemove,
    (event, data = {}) => {
      const eventName = event.name;
      const trackData = buildEventPayloadByPropsWithUserId(data, [
        'product_id',
      ]);

      track(eventName, trackData);
    },
  );

  // ProductImpression - Since app.js precedes tracker.shoplytics.js execution, it should remain in services.tracker.js.

  $rootScope.$on(
    generalEventType.ORDER_NUMBER_LINK_CLICK,
    (event, data = {}) => {
      const eventName = event.name;

      track(eventName, {
        user_id: userId,
        data: JSON.stringify(data),
      });
    },
  );

  $rootScope.$on(
    generalEventType.MEMBER_SUBSCRIPTION_BUTTON_CLICK,
    (event, data) => {
      const eventName = event.name;

      if (typeof shoplytics === 'function') {
        const trackData = getTrackData(data);

        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    generalEventType.MEMBER_SUBSCRIPTION_POPUP_CLICK,
    (event, data) => {
      const eventName = event.name;

      if (typeof shoplytics === 'function') {
        const trackData = getTrackData(data);
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    ONE_PAGE_STORE_TRACKER_TYPE.MiniCartButtonClick,
    (event, data) => {
      const eventName = event.name;
      const trackData = buildTrackDataWithScope(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    ONE_PAGE_STORE_TRACKER_TYPE.OrderCheckoutButtonClick,
    (event, data) => {
      const eventName = event.name;
      const trackData = buildTrackDataWithScope(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    ONE_PAGE_STORE_TRACKER_TYPE.ProductImpression,
    (event, data) => {
      const eventName = event.name;
      const trackData = buildTrackDataWithScope(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(ONE_PAGE_STORE_TRACKER_TYPE.CartImpression, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataWithScope(data);

    if (typeof shoplytics === 'function') {
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(ONE_PAGE_STORE_TRACKER_TYPE.CheckoutInput, (event, data) => {
    const eventName = event.name;
    const trackData = buildTrackDataWithScope(data);

    if (typeof shoplytics === 'function') {
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(generalEventType.CartMemberLoginClick, (event, data) => {
    const eventName = event.name;
    if (typeof shoplytics === 'function') {
      const trackData = getTrackData(data);
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(generalEventType.CartThirdPartySignUpClick, (event, data) => {
    const eventName = event.name;
    if (typeof shoplytics === 'function') {
      const trackData = getTrackData(data);
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.COUPON_CENTER_LINK_CLICK,
    (event, data) => {
      const eventName = event.name;
      const trackData = getTrackData(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    CART_REVAMP_TRACKER_TYPE.PaymentPromoOptionClick,
    (event, data) => {
      const eventName = event.name;
      const trackData = getTrackData(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    CART_REVAMP_TRACKER_TYPE.PaymentPromoOptionShow,
    (event, data) => {
      const eventName = event.name;
      const trackData = getTrackData(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_CLICK,
    (event, data) => {
      const eventName = event.name;
      const trackData = getTrackData(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_SHOW,
    (event, data) => {
      const eventName = event.name;
      const trackData = getTrackData(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  $rootScope.$on(CART_REVAMP_TRACKER_TYPE.AddonAllListClick, (event, data) => {
    const eventName = event.name;
    const trackData = getTrackData(data);

    if (typeof shoplytics === 'function') {
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(
    ONE_PAGE_STORE_TRACKER_TYPE.GiftCheckoutPopupShow,
    (event, data) => {
      const eventName = event.name;
      const { scope, event_category } = data;

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, {
          scope,
          event_category,
        });
      }
    },
  );

  $rootScope.$on(
    ONE_PAGE_STORE_TRACKER_TYPE.GiftCheckoutPopupClick,
    (event, data) => {
      const eventName = event.name;
      const { scope, event_category, ...rest } = data;

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, {
          scope,
          event_category,
          data: JSON.stringify(rest),
        });
      }
    },
  );

  $rootScope.$on(CART_REVAMP_TRACKER_TYPE.AddonAllListShow, (event, data) => {
    const eventName = event.name;
    const trackData = getTrackData(data);

    if (typeof shoplytics === 'function') {
      shoplytics('track', eventName, trackData);
    }
  });

  $rootScope.$on(
    generalEventType.FIXED_RECOMMENDATION_BAR_CLICK,
    (event, data) => {
      const eventName = event.name;
      const trackData = getTrackData(data);

      if (typeof shoplytics === 'function') {
        shoplytics('track', eventName, trackData);
      }
    },
  );

  // TODO: use this function for every other trackers
  const trackerCallback = (event, data) => {
    const eventName = event.name;
    const trackData = getTrackData(data);

    if (typeof shoplytics === 'function') {
      shoplytics('track', eventName, trackData);
    }
  };

  $rootScope.$on(CART_TRACKER_TYPE.ADDON_PAGE_CLICK, trackerCallback);

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_RECIPIENT_ADDRESS_TYPE,
    trackerCallback,
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.DELIVERY_OPTION_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.PAYMENT_OPTION_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_CODE_CREDIT_POINT_ENTRANCE_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_CODE_CREDIT_POINT_APPLY,
    trackerCallback,
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_MY_COUPON_APPLY,
    trackerCallback,
  );

  $rootScope.$on(
    CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_MY_COUPON_SELECT,
    trackerCallback,
  );

  $rootScope.$on(CHECKOUT_TRACKER_TYPE.CHECKOUT_CART_CLICK, trackerCallback);

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_MEMBER_LOG_IN_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_THIRD_PARTY_SIGN_UP_CLICK,
    trackerCallback,
  );

  $rootScope.$on(EVENT_NAME_FOR_CHECKOUT.CheckoutNameInput, trackerCallback);

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_PHONE_NUMBER_INPUT,
    trackerCallback,
  );

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_SAME_RECIPIENT_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_NAME_INPUT,
    trackerCallback,
  );

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_PHONE_INPUT,
    trackerCallback,
  );

  $rootScope.$on(
    CHECKOUT_TRACKER_TYPE.CHECKOUT_RECIPIENT_ADDRESS_TYPE,
    trackerCallback,
  );

  $rootScope.$on(CHECKOUT_TRACKER_TYPE.STORE_PICKUP_REMEMBER, trackerCallback);

  $rootScope.$on(
    EVENT_FOR_MEMBER_CENTER.MEMBER_REFERRAL_LINK_SHOW,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_FOR_MEMBER_CENTER.MEMBER_REFERRAL_LINK_COPY,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_FOR_MEMBER_CENTER.MEMBER_REFERRAL_SIGN_UP_POPUP_SHOW,
    trackerCallback,
  );

  $rootScope.$on(ONE_PAGE_STORE_TRACKER_TYPE.CartError, trackerCallback);

  $rootScope.$on(ONE_PAGE_STORE_TRACKER_TYPE.DeliveryChange, trackerCallback);

  $rootScope.$on(ONE_PAGE_STORE_TRACKER_TYPE.PaymentChange, trackerCallback);

  /** Menu events */

  $rootScope.$on(MENU_TRACKER_TYPE.HEADER_HAMBURGER_CLICK, trackerCallback);

  $rootScope.$on(MENU_TRACKER_TYPE.MENU_CLICK, trackerCallback);

  $rootScope.$on(MENU_TRACKER_TYPE.SEARCH_PRODUCT_ICON_CLICK, trackerCallback);

  /**
   * Global announcement bar click a link
   */
  $rootScope.$on(
    EVENT_NAME_FOR_USER_FLOW.AnnouncementBarClick,
    trackerCallback,
  );
  /**
   * Image Lightbox Popup Event
   */
  $rootScope.$on(EVENT_NAME_FOR_USER_FLOW.ImageLightboxClick, trackerCallback);

  /** Coupon Center */
  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_GO_TO_CART_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_POP_UP_IMPRESSION,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_GO_TO_CART_SHOW,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_CENTER_POP_UP_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_USE_NOW_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_IMPRESSION,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COLLECT_COUPON_CLICK,
    trackerCallback,
  );

  $rootScope.$on(
    EVENT_NAME_FOR_COUPON_CENTER.COUPON_CODE_REDEEM,
    trackerCallback,
  );

  /**
   * PDP, PLP, Blog Post, Blog listing page. Click breadCrumb event
   */
  $rootScope.$on(EVENT_NAME_FOR_USER_FLOW.BreadCrumbClick, trackerCallback);
}

app.run(['$rootScope', 'mainConfig', 'trackerService', trackerShoplytics]);
